import { render } from "./onlineorder.vue?vue&type=template&id=d45bfa56"
import script from "./onlineorder.vue?vue&type=script&lang=js"
export * from "./onlineorder.vue?vue&type=script&lang=js"

import "./onlineorder.vue?vue&type=style&index=0&id=d45bfa56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__